/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import { motion, AnimatePresence } from "framer-motion";
import { ChatCircleTextIcon, ArrowCounterClockwiseIcon } from "@phosphor-icons/react";

const statusColor = (s) => {
  if (s === "active") return "border-[#00E5FF] bg-[#00E5FF]/5 shadow-[0_0_15px_rgba(0,229,255,0.25)]";
  if (s === "read") return "border-transparent opacity-40";
  return "border-[#222233]";
};

const ChatQueue = ({ messages, onReplay }) => {
  return (
    <div className="glass rounded-2xl p-5 flex-1 flex flex-col overflow-hidden">
      <div className="flex items-center justify-between mb-4 shrink-0">
        <div className="font-display font-black text-sm uppercase tracking-widest">Chat Queue</div>
        <ChatCircleTextIcon size={16} color="#FF007F" />
      </div>
      <div className="flex-1 overflow-y-auto space-y-2 pr-1" data-testid="chat-queue">
        {messages.length === 0 && (
          <div className="text-xs text-white/30 py-8 text-center">
            Waiting for messages…
          </div>
        )}
        <AnimatePresence initial={false}>
          {messages.map((m) => (
            <motion.div
              key={m.id}
              layout
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className={`group border rounded-lg p-2.5 transition-all ${statusColor(m.status)}`}
              data-testid="chat-message"
            >
              <div className="flex items-baseline gap-2">
                <span className="text-xs font-semibold" style={{ color: m.color || "#00E5FF" }}>
                  {m.username}
                </span>
                {m.status === "active" && (
                  <span className="text-[9px] uppercase tracking-wider text-[#00E5FF]">reading</span>
                )}
                {m.status === "read" && (
                  <span className="text-[9px] uppercase tracking-wider text-white/40">done</span>
                )}
                {onReplay && (m.status === "read" || m.status === "queued") && (
                  <button
                    onClick={() => onReplay(m)}
                    data-testid={`replay-${m.id}`}
                    title="Replay this message"
                    className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity text-[10px] text-[#39FF14] hover:text-[#5CFF3C] flex items-center gap-1"
                  >
                    <ArrowCounterClockwiseIcon size={11} weight="bold" /> replay
                  </button>
                )}
              </div>
              <div className="text-xs text-white/80 mt-1 break-words">{m.text}</div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default ChatQueue;
